import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=1554cacf&scoped=true&"
var script = {}
import style0 from "./HelpPanel.vue?vue&type=style&index=0&id=1554cacf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1554cacf",
  null
  
)

export default component.exports